/* Cupón ADDONS20 (aprobado por Jose el 15/10/2026).
   Popup A una sola vez por visitante en las páginas de módulos PrestaShop; al verlo, la barra C
   queda para siempre en todas las páginas (html.lg-a20-c, que pone el <head> antes de pintar).
   No sale a navegadores automatizados, bots ni agentes, con el chat abierto ni encima del aviso
   de cookies. En escritorio, a los 4 s; en móvil, tras bajar un 25 % de la página o a los 10 s.
   GA4 (por dataLayer/gtag, como el chatbot): cupon_popup_mostrado, cupon_popup_cerrado {como},
   cupon_barra_mostrada (una vez por visita), cupon_barra_clic y cupon_copiado {origen}.
   La cookie lg_cupon_via (popup_a | barra_c) la lee WHMCS al cerrar el pedido para el purchase;
   solo se escribe con permiso de analítica. */
(function () {
  'use strict';
  var html = document.documentElement;
  var barra = document.querySelector('.lg-a20-barra');
  if (!barra) return;
  var plantilla = document.getElementById('lg-a20-popup');
  var idioma = barra.getAttribute('lang') || html.lang || '';
  var tipo = barra.dataset.tipo || '';
  var AUTOMATA = navigator.webdriver === true ||
    /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|preview|python|curl|wget|httpclient|axios|node-fetch|playwright|puppeteer|selenium|phantom|gpt|openai|claude|anthropic|perplexity|bytespider|ccbot|cohere|diffbot|agent/i.test(navigator.userAgent || '');
  var DEMO = /[?&]lg_a20=demo(&|$)/.test(location.search); // ?lg_a20=demo: popup a los 2 s aunque ya se viera

  function lee(clave, sesion) { try { return (sesion ? sessionStorage : localStorage).getItem(clave); } catch (e) { return null; } }
  function guarda(clave, valor, sesion) { try { (sesion ? sessionStorage : localStorage).setItem(clave, valor); } catch (e) {} }

  // GA4 (vía GTM) agrupa los eventos y los manda unos 5 s después; si la página cambia antes, el lote se
  // pierde (comprobado en Tiempo real, también con beacon y event_callback). Al salir se guardan los de los
  // últimos 5,5 s en sessionStorage y la página siguiente los reenvía.
  var recientes = [];
  function manda(nombre, p) {
    recientes.push({ n: nombre, p: p, t: Date.now(), u: location.href });
    try {
      if (typeof window.gtag === 'function') window.gtag('event', nombre, p);
      else { window.dataLayer = window.dataLayer || []; (function () { window.dataLayer.push(arguments); })('event', nombre, p); }
    } catch (e) {}
  }
  function ga(nombre, extra) {
    var p = { cupon: 'ADDONS20', pagina_tipo: tipo, idioma: idioma };
    for (var k in extra) p[k] = extra[k];
    manda(nombre, p);
  }
  window.addEventListener('pagehide', function () {
    var ahora = Date.now();
    var pendientes = recientes.filter(function (e) { return ahora - e.t < 5500; });
    if (pendientes.length) guarda('lg_a20_pendientes', JSON.stringify(pendientes), true);
  });
  (function () {
    var pendientes = lee('lg_a20_pendientes', true);
    if (!pendientes) return;
    try { sessionStorage.removeItem('lg_a20_pendientes'); } catch (e) {}
    // reenviado=1 marca el duplicado si algún navegador sí llegó a mandar el lote; page_location, la del clic.
    try {
      JSON.parse(pendientes).forEach(function (e) {
        var p = {}; for (var k in e.p) p[k] = e.p[k];
        p.reenviado = 1; if (e.u) p.page_location = e.u;
        manda(e.n, p);
      });
    } catch (e) {}
  })();

  function analiticaPermitida() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }
  function via(valor) {
    if (!analiticaPermitida()) return;
    var d = new Date(Date.now() + 180 * 864e5);
    document.cookie = 'lg_cupon_via=' + valor + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax; Secure' +
      (/(^|\.)lineagrafica\.es$/.test(location.hostname) ? '; domain=.lineagrafica.es' : '');
  }

  function copiar(btn, origen) {
    var codigo = btn.previousElementSibling;
    var hecho = function () {
      var antes = btn.textContent;
      btn.textContent = btn.dataset.copiado; btn.classList.add('ok');
      setTimeout(function () { btn.textContent = antes; btn.classList.remove('ok'); }, 2000);
    };
    var aMano = function () {
      try {
        var r = document.createRange(); r.selectNodeContents(codigo);
        var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
        if (document.execCommand('copy')) hecho();
      } catch (e) {}
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText('ADDONS20').then(hecho, aMano);
    else aMano();
    ga('cupon_copiado', { origen: origen });
    via(origen);
  }

  /* ---------- Barra C ---------- */
  var barraContada = false;
  function barraMostrada() {
    if (barraContada || !html.classList.contains('lg-a20-c')) return;
    barraContada = true;
    if (lee('lg_a20_barra', true) === '1') return;
    guarda('lg_a20_barra', '1', true);
    ga('cupon_barra_mostrada');
  }
  barra.addEventListener('click', function (ev) {
    var b = ev.target.closest('.lg-a20-copiar');
    if (b) { copiar(b, 'barra_c'); return; }
    if (ev.target.closest('[data-a20-clic]')) { ga('cupon_barra_clic'); via('barra_c'); }
  });
  barraMostrada();

  /* ---------- Popup A ---------- */
  if (!plantilla || AUTOMATA || (lee('lg_a20_visto_v3') === '1' && !DEMO)) return;

  var fondo = null, dialogo = null, previo = null;
  function enfocables() {
    return Array.prototype.filter.call(dialogo.querySelectorAll('a[href],button:not([disabled])'),
      function (e) { return e.offsetParent !== null; });
  }
  function teclas(e) {
    if (!fondo) return;
    if (e.key === 'Escape') { e.preventDefault(); cerrar('esc'); return; }
    if (e.key !== 'Tab') return;
    var f = enfocables(); if (!f.length) return;
    var pri = f[0], ult = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === pri || document.activeElement === dialogo)) { e.preventDefault(); ult.focus(); }
    else if (!e.shiftKey && document.activeElement === ult) { e.preventDefault(); pri.focus(); }
    else if (!dialogo.contains(document.activeElement)) { e.preventDefault(); pri.focus(); }
  }
  function cerrar(como) {
    if (!fondo) return;
    fondo.remove(); fondo = null;
    document.removeEventListener('keydown', teclas, true);
    ga('cupon_popup_cerrado', { como: como });
    html.classList.add('lg-a20-c');
    barraMostrada();
    if (previo && previo.focus && document.contains(previo)) { try { previo.focus({ preventScroll: true }); } catch (e) {} }
  }
  function bloqueado() {
    var chat = document.querySelector('.lgc-panel');
    if (chat && !chat.hidden) return true;
    // Popup de Connectif (newsletter) abierto: no se apila encima; se espera a que lo cierren.
    var cn = document.querySelector('[class^="cn_content_backdrop"],[class*=" cn_content_backdrop"]');
    if (cn && cn.getBoundingClientRect().width > 0 && getComputedStyle(cn).visibility !== 'hidden') return true;
    var aviso = document.getElementById('shopify-pc__banner');
    if (aviso && aviso.offsetParent !== null && getComputedStyle(aviso).visibility !== 'hidden') return true;
    // Otro modal o cajón del tema abierto de verdad: el tema bloquea el scroll del body al abrirlos,
    // y los cerrados siguen en el DOM sin ocupar pantalla (el menú de la cuenta es pequeño y no cuenta).
    if (/overflow-hidden/.test(document.body.className)) return true;
    return Array.prototype.some.call(document.querySelectorAll('[role="dialog"][aria-modal="true"]'), function (d) {
      var r = d.getBoundingClientRect();
      return r.width * r.height > 0.4 * innerWidth * innerHeight && getComputedStyle(d).visibility !== 'hidden';
    });
  }
  function abrir() {
    if (fondo) return;
    if (document.hidden || bloqueado()) { setTimeout(abrir, 3000); return; }
    previo = document.activeElement;
    fondo = plantilla.content.firstElementChild.cloneNode(true);
    dialogo = fondo.querySelector('[role="dialog"]');
    document.body.appendChild(fondo);
    fondo.addEventListener('click', function (ev) {
      var c = ev.target.closest('[data-a20-cerrar]');
      var b = ev.target.closest('.lg-a20-copiar');
      if (c) {
        // El botón del catálogo navega (salvo si ya estamos en él); el resto solo cierra.
        if (c.tagName !== 'A' || c.pathname === location.pathname) ev.preventDefault();
        cerrar(c.dataset.a20Cerrar);
      } else if (b) copiar(b, 'popup_a');
      else if (ev.target === fondo) cerrar('fondo');
    });
    document.addEventListener('keydown', teclas, true);
    dialogo.focus({ preventScroll: true });
    guarda('lg_a20_visto_v3', '1');
    guarda('lg_addons20_popup', '1', true); // el chatbot no se abre solo en esta visita
    ga('cupon_popup_mostrado');
    via('popup_a');
  }

  var movil = window.matchMedia('(max-width: 640px)').matches;
  var espera = DEMO ? 2000 : (movil ? 10000 : 4000);
  var reloj = setTimeout(abrir, espera);
  if (movil && !DEMO) {
    var alBajar = function () {
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      if (alto > 0 && window.scrollY / alto >= 0.25) {
        window.removeEventListener('scroll', alBajar);
        clearTimeout(reloj); abrir();
      }
    };
    window.addEventListener('scroll', alBajar, { passive: true });
  }
})();
